import { render } from "./SystemAIConfig.vue?vue&type=template&id=4fe7820f&scoped=true"
import script from "./SystemAIConfig.vue?vue&type=script&lang=js"
export * from "./SystemAIConfig.vue?vue&type=script&lang=js"

import "./SystemAIConfig.vue?vue&type=style&index=0&id=4fe7820f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fe7820f"]])

export default __exports__